import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.175 16H3a.97.97 0 0 1-.712-.287A.97.97 0 0 1 2 15a.97.97 0 0 1 .288-.713A.97.97 0 0 1 3 14h6.175L7.3 12.125a.93.93 0 0 1-.275-.688q0-.411.275-.712.3-.3.712-.3.413 0 .713.3L12.3 14.3q.15.15.212.325.063.175.063.375c0 .2-.02.258-.063.375a.9.9 0 0 1-.212.325l-3.6 3.6q-.3.3-.7.287a1 1 0 0 1-.7-.312q-.276-.3-.287-.7a.92.92 0 0 1 .287-.7zm5.65-6 1.875 1.875a.93.93 0 0 1 .275.688q0 .411-.275.712-.3.3-.712.3a.97.97 0 0 1-.713-.3L11.7 9.7a.9.9 0 0 1-.212-.325A1.1 1.1 0 0 1 11.425 9q0-.2.063-.375A.9.9 0 0 1 11.7 8.3l3.6-3.6q.3-.3.7-.288t.7.313q.275.3.288.7a.92.92 0 0 1-.288.7L14.825 8H21a.97.97 0 0 1 .712.287Q22 8.575 22 9c0 .425-.096.52-.288.713A.97.97 0 0 1 21 10z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }